export { default } from './FullBackgroundImgArticleCard';
